export const presetSpaceFunctionsCols = [
  { header: "", accessor: "id" },
  { header: "Name", accessor: "name" },
  { header: "Description", accessor: "description" },
];

export const presetBuildingParametersCols = [
    { header: '', accessor: 'id' },
    { header: 'Name', accessor: 'name' },
    { header: 'Description', accessor: 'description' },
    { header: 'Type', accessor: 'type' },
    { header: 'Creation', accessor: 'creationType' },
    { header: 'Min', accessor: 'min' },
    { header: 'Max', accessor: 'max' },
    { header: 'Value', accessor: 'value' },
  ]